



































/* General */
import Vue from 'vue'
import { RawLocation } from 'vue-router'
import { cloneDeep } from 'lodash'
import moment from 'moment'

/* Mixins */

/* Components */
import CalendarDatePicker from '../components/calendar-date-picker.vue'
import CalendarPersonPicker from '../components/calendar-person-picker.vue'

/* Helpers */

/* Data types */
import {
  ICalendarOutputFilterOptions,
  IPersonBase,
} from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'CalendarSidebar',

  components: {
    CalendarDatePicker,
    CalendarPersonPicker,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    daysWithDeadlines: {
      type: Array as () => string[],
      required: true,
    },
    filterOptions: {
      type: Object as () => ICalendarOutputFilterOptions,
      required: true,
    },
  },

  data() {
    return {
      date: this.$route.query.date,
      selectedPeopleIDs: [],
      selectedEntityID: null,
    }
  },

  computed: {
    filtersSelected(): boolean {
      return (
        (this.selectedEntityID !== null && this.selectedEntityID !== 0) ||
        this.selectedPeopleIDs.length > 0
      )
    },
    people(): IPersonBase[] {
      let result = [] as IPersonBase[]
      if (!this.filterOptions.listCompanies) {
        return result
      }
      this.filterOptions.listCompanies.forEach(c => {
        result = result.concat(c.listPeople)
      })
      return result.sort((a, b) => (a.name > b.name ? 1 : -1))
    },
    dots(): any {
      return this.daysWithDeadlines.map((item: any, index: number) => ({
        id: index,
        description: '',
        date: item,
        color: '#fa6123',
      }))
    },
    /**
     * Create obj query to history
     */
    paramsToHistory(): object {
      return {
        ...this.mergeIntoParams('date', moment(this.date).format('YYYY-MM-DD')),
        ...this.mergeIntoParams('entity_id', this.selectedEntityID),
        ...this.mergeIntoParams(
          'people_ids',
          this.selectedPeopleIDs.length ? this.selectedPeopleIDs.join() : null,
        ),
      }
    },
    showMailboxes(): boolean {
      return this.$permissions.isNotGuest
    },
  },

  watch: {
    date: {
      immediate: true,
      async handler(value) {
        const formattedDate = moment(value).format('YYYY/MM/DD')
        this.date = formattedDate
      },
    },
    paramsToHistory: {
      immediate: false,
      async handler(value) {
        this.replaceRouter(value)
      },
    },
    filterOptions: {
      immediate: false,
      async handler(val) {
        this.selectedEntityID = this.$route.query.entity_id
          ? Number(this.$route.query.entity_id)
          : null

        let selectPeopleIDStrings = [] as string[]
        if (Array.isArray(this.$route.query.people_ids)) {
          selectPeopleIDStrings = this.$route.query.people_ids
        } else if (this.$route.query.people_ids) {
          selectPeopleIDStrings = this.$route.query.people_ids.split(',')
        }

        this.selectedPeopleIDs = selectPeopleIDStrings.map(id => Number(id))
      },
    },
  },

  methods: {
    mergeIntoParams(attr: string, value: any) {
      const obj: any = {}
      if (value) {
        obj[attr] = cloneDeep(value)
      }
      return obj
    },

    replaceRouter(value: RawLocation) {
      this.$router.replace({ query: value } as RawLocation)
    },

    resetFilters() {
      this.selectedPeopleIDs = []
      this.selectedEntityID = null
    },
  },
})
